module.exports = __webpack_public_path__ + "static/navbarlogo-tr-a7b7ceaddc9312e92df69c685ca752b3.png";